import { type ReactNode } from "react";
import PageTitle from "../PageTitle/PageTitle";

type BackofficePageProps = {
  title: string;
  children: ReactNode;
  className?: string;
  titleClassName?: string;
  fullHeight?: boolean;
};

const BackofficePage = ({
  title,
  children,
  className = "",
  titleClassName = "",
  fullHeight = false
}: BackofficePageProps) => {
  return (
    <div className={`p-4 sm:p-14 ${fullHeight ? "flex-1 flex flex-col" : ""} ${className}`.trim()}>
      <PageTitle className={`my-6 sm:my-0 sm:mb-8 ${titleClassName}`.trim()}>
        {title}
      </PageTitle>
      {children}
    </div>
  );
};

export default BackofficePage;
